import { Component, OnInit } from '@angular/core';
import { Porteur } from "../../shared/porteur";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-marquage',
  templateUrl: './marquage.component.html',
  styleUrls: ['./marquage.component.scss']
})
export class MarquageComponent implements OnInit {

  porteur: Porteur;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.getPorteur();
  }

  getPorteur() {
    this.route.data.subscribe(data => {
      this.porteur = data.porteur;
    })
  }
}
